// extracted by mini-css-extract-plugin
export default {"newAddress":"CustomerAddresses_newAddress__9ZOj0","create":"CustomerAddresses_create__VnFJW","delete":"CustomerAddresses_delete__iStN8","address":"CustomerAddresses_address__bw8VP"};